import React, { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "../../ui/avatar";
import ReadsModal from "./ReadsModal";
import { defaultPfpUrl } from "../../utils";
import { cn } from "../../../lib/utils";

/** Max tiny PFPs shown before overflow "...". */
const VISIBLE_CAP = 8;

/**
 * Tiny right-aligned read receipts under a message.
 * @param {Object} props
 * @param {Array<{ user_id: number, name?: string, pfp?: string }>} props.readers
 * @returns {JSX.Element | null}
 */
function MessageReadIndicators({ readers }) {
  const [modalOpen, setModalOpen] = useState(false);
  const list = Array.isArray(readers) ? readers : [];

  if (list.length === 0) {
    return null;
  }

  const visible = list.slice(0, VISIBLE_CAP);
  const hasOverflow = list.length > VISIBLE_CAP;

  return (
    <>
      <div
        className={cn(
          "mt-1.5 flex w-full items-center justify-end gap-0.5 px-2"
        )}
        aria-label="Read by"
      >
        {visible.map((user) => (
          <Avatar
            key={user.user_id}
            className="h-3.5 w-3.5 shrink-0"
            title={user.name || "User"}
          >
            <AvatarImage
              src={user.pfp || defaultPfpUrl}
              alt={user.name || "Reader"}
              onError={(e) => {
                e.target.src = defaultPfpUrl;
              }}
            />
            <AvatarFallback className="text-[7px]">
              {(user.name || "?").slice(0, 1).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        ))}
        {hasOverflow ? (
          <button
            type="button"
            onClick={() => setModalOpen(true)}
            className="inline-flex h-3.5 min-w-3.5 items-center justify-center rounded-full px-0.5 text-[10px] leading-none text-text-muted transition-colors hover:text-text-primary"
            aria-label={`View all ${list.length} readers`}
            title="View all readers"
          >
            …
          </button>
        ) : null}
      </div>
      {hasOverflow ? (
        <ReadsModal
          open={modalOpen}
          onOpenChange={setModalOpen}
          readers={list}
        />
      ) : null}
    </>
  );
}

export default MessageReadIndicators;
